import { RefObject, useEffect } from "react";
import { Certificate, CertificateType } from "./Certificate";
import { useTranslation } from "react-i18next";
import { useThemeUpdater } from "./useThemeUpdater";
import { getDefaultChecks, ProcessedProgress } from "./progressModel";


interface CertificateFromProgressProps {
  forwardCanvasRef?: RefObject<HTMLCanvasElement>;
  width: number;
  height: number;
  scale: number;
  registerBlobGetter?: (getter: () => Promise<Blob>) => void;
  name: string;
  processedProgress: ProcessedProgress | null;
  onCheckClick?: (checkKey) => void;
}

export const CerfificateFromProgress: React.FC<CertificateFromProgressProps> = ({
  forwardCanvasRef, width, height, scale, registerBlobGetter,
  name, processedProgress, onCheckClick
}) => {
  const isMyCertificate = !!forwardCanvasRef;
  const { t } = useTranslation();
  const { updateTheme } = useThemeUpdater();

  const pp = processedProgress || {
    certificateType: CertificateType.GREEN,
    checks: getDefaultChecks(t)
  }

  const rank = pp.certificateType === CertificateType.GOLD
    ? t("challenge.rank.gold")
    : pp.certificateType === CertificateType.SILVER
    ? t("challenge.rank.silver")
    : pp.certificateType === CertificateType.BRONZE
    ? t("challenge.rank.bronze")
    : t("challenge.rank.green");

  const certSubheader = !name
    ? (isMyCertificate ? t('challenge.cert.my-buy-european.unnamed.subheader') : t('challenge.cert.their-buy-european.unnamed.subheader'))
    : pp.certificateType === CertificateType.GREEN
    ? (isMyCertificate ? t('challenge.cert.my-buy-european.named.subheader', { name }) : t('challenge.cert.their-buy-european.named.subheader', { name }))
    : t('challenge.cert.my-buy-european.named.upgraded.subheader', { name, rank });


  useEffect(() => {
    updateTheme(pp.certificateType);
  }, [pp]);

  return <Certificate 
    forwardCanvasRef={forwardCanvasRef}
    type={pp.certificateType}
    width={width}
    height={height}
    scale={scale}
    registerBlobGetter={registerBlobGetter}
    header={t('challenge.cert.buy-european-challenge.header')}
    subheader={certSubheader}
    checks={pp.checks}
    onCheckClick={onCheckClick}
  />
}

